import React, { useState } from "react";
import SureModal from "../SureModal";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const Modal = ({ isOpen, onClose, title,action,actionType }) => {
  const [sureModalOpen, setSureModalOpen] = useState(false); // State to manage SureModal visibility
  const { COLORS } = useThemeMode();

  // Function to handle opening SureModal
  const openSureModal = () => {
    console.log("In open sure modal func")
    onClose(); // Close the current modal
    setSureModalOpen(true); // Open the SureModal
  };

  const handleConfirm = () => {
    console.log("In handle confirm func")
    action();
    setSureModalOpen(false)
    onClose();
  };

  const isDeactivate = actionType === "Deactivate";

  return (
    <>
      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: isOpen ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ background: COLORS.primary }}>
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold" style={{ color: COLORS.text }}>
                {actionType} The {title}
              </h5>

              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <span className="fw-normal" style={{ color: COLORS.text }}>
                Are you sure you want to <b>{actionType?.toLowerCase()}</b> the {title}? <br />
                <div style={{ marginBottom: "10px" }}></div>
                 {isDeactivate
                  ? `Deactivating a ${title} will immediately suspend all related users and resources. This action is irreversible.`
                  : `Activating a ${title} will allow related users and resources to function again.`}
              </span>
            </div>
            <div className="modal-footer d-flex flex-column justify-content-center border-0">
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                style={{ background: COLORS.button, color: COLORS.background }}
                onClick={openSureModal} // Open SureModal on click
              >
                {actionType} {title}
              </button>
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                onClick={onClose}
                style={{ background: COLORS.background, color: COLORS.button }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <SureModal
        isOpen={sureModalOpen}
        onClose={() => setSureModalOpen(false)}
        onConfirm={handleConfirm} // Pass handleConfirm function as prop to SureModal
        title={title}
        actionType={actionType} 
      />
    </>
  );
};

export default Modal;